import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import { FilterLocations } from '../../common/FilterLocations';
import {
  filterButtonStyles,
  FilterWrapper,
  SearchBarWrapper,
  SearchPageFiltersContainer,
  GoBackButton
} from './styled';
import { BuildingTypeFilter } from '../BuildingTypeFilter';
import useScreenSize from '../../../../hooks/useScreenSize';
import { LeasedFilter } from '../LeasedFilter';
import { Button } from '../../../ui/Button';
import { ButtonType } from '../../../../styled/theme/types';
import Icon from '../../../Icon';
import FilterIcon from '../../../../public/static/images/new_search/icons/icon-filter.svg';
import { RoomsFilter } from '../RoomsFilter';
import { FLAT_CATEGORIES } from '../../../../utils/helpers/constants';
import { AreaFilter } from '../AreaFilter';
import { PriceFilter } from '../PriceFilter';
import { ModalParams } from '../types';

type SearchPageFiltersProps = {
  shortMode?: boolean;
  canGoBack?: boolean;
  isShowHomeFilters: boolean;
  onGoBack?: () => void;
  setModalParams: React.Dispatch<React.SetStateAction<ModalParams>>;
};

export const SearchPageFilters = ({
  setModalParams,
  shortMode,
  canGoBack,
  isShowHomeFilters,
  onGoBack
}: SearchPageFiltersProps) => {
  const { t } = useTranslation();
  const { isSmall, isLarge, isMedium } = useScreenSize();
  const { values } = useFormState();
  const isFlatCategory = FLAT_CATEGORIES.includes(values.category_id);

  const openFilters = () =>
    setModalParams({
      initialScreen: 'filters'
    });

  const filtersConfig = [
    {
      component: LeasedFilter,
      order: 1
    },
    {
      component: BuildingTypeFilter,
      order: 2
    },
    {
      component: PriceFilter,
      order: isSmall ? 3 : 4
    },
    {
      component: isFlatCategory ? RoomsFilter : AreaFilter,
      condition: isShowHomeFilters ? true : !isMedium,
      order: isSmall ? 4 : 3
    }
  ];

  const sortedFiltersConfig = filtersConfig
    .filter(({ condition = true }) => condition)
    .sort((a, b) => a.order - b.order);

  return (
    <SearchPageFiltersContainer
      $canGoBack={canGoBack}
      $isShowHomeFilters={isShowHomeFilters}
    >
      {canGoBack && (
        <GoBackButton data-cy="go-back-button" onClick={onGoBack} />
      )}

      {!shortMode && (
        <>
          {sortedFiltersConfig.map(({ component: FilterComponent, order }) => (
            <FilterWrapper key={order.toString()}>
              <FilterComponent submitOnChange />
            </FilterWrapper>
          ))}
        </>
      )}

      <SearchBarWrapper
        canGoBack={canGoBack && shortMode}
        $isShowHomeFilters={isShowHomeFilters}
      >
        <FilterLocations setModalParams={setModalParams} />
      </SearchBarWrapper>

      <Button
        onClick={openFilters}
        onKeyPress={openFilters}
        cypress="new-search-filters-button"
        stat="new-search-filters-button"
        styles={filterButtonStyles(isShowHomeFilters)}
        state={ButtonType.white}
      >
        <Icon
          width={20}
          height={20}
          indent={false}
          IconComponent={FilterIcon}
        />
        {isLarge && t('search.buttons.filters')}
      </Button>
    </SearchPageFiltersContainer>
  );
};
